import React from 'react';
import PropTypes from 'prop-types';
import { Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import { Clock } from '../../../images';
import styled from '@emotion/styled';

// Hide Chromes native calendar icon
const TimeInput = styled(Input)`
  ::-webkit-calendar-picker-indicator {
    display: none;
  }
`;

const ChablaTimePicker = ({ onChange, isValid, format, value, ...rest }) => {
  return (
    <InputGroup>
      <TimeInput
        {...rest}
        format={format}
        onChange={onChange}
        value={value}
        className="customDateTimePicker customDateTimePickerPadding"
        isInvalid={!isValid}
        type="time"
        errorBorderColor="brand.50"
        bg="brand.10"
        borderRadius={0}
        pattern="[0-9]{2}:[0-9]{2}" // backup pattern for browser that don't support type="time"
      />
      <InputRightElement>
        <Clock style={{ maxWidth: 'unset' }} />
      </InputRightElement>
    </InputGroup>
  );
};

ChablaTimePicker.propTypes = {
  onChange: PropTypes.func,
  isValid: PropTypes.bool,
  format: PropTypes.string,
  value: PropTypes.string,
};

ChablaTimePicker.defaultProps = {
  onChange: () => {},
  isValid: true,
};

export default ChablaTimePicker;
